import { api } from "./api";
import { BancoResponse } from "../types/puesto";

export const BancoService = {
    //Obtener todos los bancos
    getAll: (activo: boolean) => {
        return api.get(`/bancos/${activo ? 1 : 0}`);
    },

    //Obtener por id
    getById: (id: number) => {
        if (!Number.isInteger(id) || id < 0) {
            throw new Error("ID debe ser un número positivo");
        }
        return api.get(`bancos/${id}/individual`)
    },

    //Crear banco
    create: (data: BancoResponse) => {
        return api.post("bancos", data);
    },

    //Actualizar banco
    update: (id: number, data: BancoResponse) => {
        if (!Number.isInteger(id) || id < 0) {
            throw new Error("ID debe ser un número positivo");
        }
        return api.put(`bancos/${id}/actualizar`, data);
    },

    // Desactivar banco
    desactivar: (id: number) => {
        return api.put(`/bancos/${id}/desactivar`);
    },

    // Activar banco
    activar: (id: number) => {
        return api.put(`/bancos/${id}/activar`);
    },
}